// eslint-disable-next-line import/prefer-default-export
export const YesNoAction = {
  yes: { label: 'Так', value: 'YES' },
  no: { label: 'Ні', value: 'NO' },
};
